export default __webpack_public_path__ + "static/media/pcard4.7cb6b721.webp";